/**
 * Shared settings option arrays used by both web and mobile settings screens.
 * Single source of truth for dropdown/picker values.
 *
 * NOTE: For complex options (companions, pace, budget) the canonical {value, label}
 * shape lives in `onboardingSchema.js` — re-exported below so consumers can
 * use either shape without diverging.
 */

import { COMPANION_OPTIONS as _CANONICAL_COMPANION_OPTIONS } from './onboardingSchema.js';

export const PACE_OPTIONS = ['relaxed', 'moderate', 'packed'];

export const BUDGET_OPTIONS = ['budget', 'moderate', 'luxury', 'custom'];

// Companions is a multi-select array (see onboardingSchema.COMPANION_OPTIONS).
// Re-exported here for the mobile/web settings screens that import from
// settingsConstants. Each entry has {value, label, icon, description, base}.
export const COMPANION_OPTIONS = _CANONICAL_COMPANION_OPTIONS;

export const INTEREST_OPTIONS = [
  'Museums', 'Hiking', 'Beaches', 'Architecture', 'Street Food',
  'Fine Dining', 'Wine/Beer', 'Photography', 'History', 'Art',
  'Music', 'Sports', 'Wellness/Spa', 'Local Markets',
];

export const CABIN_OPTIONS = [
  { value: 'ECONOMY', label: 'Economy' },
  { value: 'PREMIUM_ECONOMY', label: 'Premium Economy' },
  { value: 'BUSINESS', label: 'Business' },
  { value: 'FIRST', label: 'First' },
];

export const DIETARY_OPTIONS = [
  'Vegetarian', 'Vegan', 'Pescatarian', 'Gluten-Free', 'Dairy-Free',
  'Nut Allergies', 'Shellfish/Fish Allergy', 'Low-Carb/Keto',
  'Diabetic Diet', 'Kosher', 'Halal', 'None',
];

export const CURRENCY_OPTIONS = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '\u20AC', name: 'Euro' },
  { code: 'GBP', symbol: '\u00A3', name: 'British Pound' },
  { code: 'JPY', symbol: '\u00A5', name: 'Japanese Yen' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
];

export const CUISINE_OPTIONS = [
  'Italian', 'Japanese', 'Mexican', 'Thai', 'Indian', 'Chinese',
  'French', 'Korean', 'Vietnamese', 'Mediterranean', 'Middle Eastern',
  'American', 'Spanish', 'Greek', 'Turkish', 'Brazilian', 'Ethiopian',
];

export const ACCESSIBILITY_OPTIONS = [
  'Wheelchair accessible', 'Limited mobility', 'Visual impairment',
  'Hearing impairment', 'Service animal',
];

export const SAFETY_OPTIONS = [
  { value: 'lgbtq', label: 'LGBTQ+ friendly destinations preferred' },
  { value: 'solo_female', label: 'Solo female traveler safety' },
  { value: 'religious', label: 'Religious/cultural considerations' },
];

/** Maximum trip length in days */
export const MAX_TRIP_DAYS = 14;
